// Modules
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// Assets
import QuoteMark from "../../../assets/svg/quoteMark";
import QuoteMarkRotated from "../../../assets/svg/quoteMarkRotated";

// Components
import CustomGatsbyImage from "../gatsbyImage";

// Constants
import COLORS from "../../constants/colors";

// Styles
import * as styles from "./testimonials.module.scss";

const Testimonials = (props) => {
  const { author, bgColor, ctDirection, logo, role, subtitleText, quote } =
    props;

  const authorText = subtitleText ? subtitleText : `${author} ${role}`;
  const contentClass = cx({
    [styles.centredContent]: !ctDirection,
    [styles.testimonialsWrapper]: true,
    [styles.pinkBack]: bgColor === true,
  });

  const quotesColor = bgColor ? "currentColor" : COLORS.pink;

  return (
    <div
      className={cx({
        [styles.pinkBack]: bgColor === true,
        [styles.container]: true,
      })}
    >
      <div className={contentClass}>
        <QuoteMarkRotated
          className={styles.quoteIconRotated}
          fill={quotesColor}
        />
        <QuoteMark className={styles.quoteIcon} fill={quotesColor} />
        <span>
          <div className={styles.h4}>{`“${quote}”`}</div>
        </span>
        <div className={styles.signatureWrapper}>
          <div className={styles.h5}>{authorText}</div>
          {logo?.image?.asset && (
            <div className={styles.logo}>
              <CustomGatsbyImage
                alt={logo.alt}
                img={logo.image.asset}
                height={51}
                width={130}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Testimonials.propTypes = {
  author: PropTypes.string,
  ctDirection: PropTypes.bool,
  logo: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  role: PropTypes.string,
  titleText: PropTypes.string,
};

Testimonials.defaultProps = {
  author: "",
  ctDirection: false,
  logo: false,
  role: "",
  titleText: "",
};

export default Testimonials;
